import React from 'react';
import Footer from '../../../layout/Footer/Footer';

const DefaultFooter = () => {
	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col'>{`Copyright © ${new Date().getFullYear()}`}</div>
					<div className='col-auto'>
						Designed and developed by{' '}
						<a target='blank' href='https://www.conviersolutions.com'>
							{' '}
							ConvierSolutions
						</a>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
